import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "../../utils/authStorage";
import UserSessionManager from "../../utils/UserSessionManager";

export default function ChangePasswordRoute({ children }) {
  const location = useLocation();
  const token = getAccessToken();
  const email = location.state?.email;
  const forced = UserSessionManager.requiresPasswordChange();

  if (token && forced) {
    return children;
  }

  if (!token && email) {
    return children;
  }

  if (token && !forced) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/signin" replace />;
}
